const isDescendant = (el, parentId) => {
  let isChild = false

  if (el.id === parentId) { //is this the element itself?
    isChild = true
  }

  while (el = el.parentNode) {
    if (el.id == parentId) {
      isChild = true
    }
  }
  
  return isChild
}

export {isDescendant};

/* IN USE */

// document.addEventListener('click', event => {
//   const parentId = 'mycontainer'

//   if (isDescendant(event.target, parentId)) {
//     //it is a descendant, handle this case here
//   } else {
//     //it's not a descendant, handle this case here
//   }
// })